
/* eslint-disable*/
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";


const MonthlyTrendChart = ({ data }) => {

const maxValue = Math.max(
    ...data.datasets.flatMap(ds => ds.data),
    0
  );

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
const options = {
  responsive: true,
  plugins: {
    legend: { display: false },
    datalabels: {
      color: "black",
     anchor: 'end',
    align: 'top',
      font: {
        weight: "bold",
        size: 12,
      },
    },
  },
  scales: {
    x: {
      ticks: { autoSkip: false, maxRotation: 45, minRotation: 45,font: {
        size: 8,
      }},
      grid: { display: false },
      
    },
    y: { 
      beginAtZero: true, 
      // max:50,
      max: maxValue + 10,
      stepSize: 5 ,
    grid: {display: false}}

  }
};



  return(<div style={{ minWidth: 'auto' }}>
    <Bar data={data} options={options} />
  </div>
);
}
export default MonthlyTrendChart;



